<script setup lang="ts">
import { RouterView } from 'vue-router'
import { Toaster } from '@/components/ui/sonner'
import { PwaBanner } from '@/components/core/pwa'
import { MessageSquareIcon } from 'lucide-vue-next'
import { useColorMode } from '@vueuse/core'

useColorMode().value = 'light'
</script>

<template>
    <RouterView />

    <Toaster></Toaster>
</template>

<style scoped></style>
